// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"108":"37126b11c1b84fb9c012","452":"4599326ac160d57689cc"}[chunkId] + ".js";
};